// extracted by mini-css-extract-plugin
export var cardHeader = "_g3-0";
export var reorderHandle = "_g3-3";
export var titleArea = "_g3-1";
export var titleAreaWithHandle = "_g3-2";